import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { WCGuard } from 'src/app/guards/wc.guard';
import { MainComponent } from './main.component';

const routes: Routes = [

  {
    path: 'p/:alias',
    canActivate: [WCGuard],
    children: [
      {
        path: '**',
        component: MainComponent,
      }
    ]
  },

  {
    path: '',
    canActivate: [WCGuard],
    data: { routeException: true },
    children: [
      {
        path: '**',
        component: MainComponent,
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class MainRoutingModule { }